import { isTaskEffectivelyCompleted } from '../../FlowchartView/utils/dependencyUtils/helpers';

// Presentation only. The existing availability/condition engine remains authoritative.
export function createIgnitionSnapshot({ campaignId, tasks, statuses, lockStates, availableTasks, nestedSprints, graph }) {
  const byId = new Map(tasks.map((task) => [task.id, task]));
  const edges = graph.edges.map(([a, b]) => [graph.nodes[a].id, graph.nodes[b].id]);
  return {
    campaignId,
    // A filter, condition edit, decision, or status-definition edit is not a completion.
    context: JSON.stringify([
      tasks.map((t) => [t.id, t.unlockConditions, t.dependsOn, t.answer, t.selectedOption, t.nestedSprintId]).sort((a, b) => String(a[0]).localeCompare(String(b[0]))),
      statuses,
    ]),
    edges,
    completed: new Set(tasks.filter((t) => isTaskEffectivelyCompleted(t, nestedSprints, statuses)).map((t) => t.id)),
    available: new Set(availableTasks.filter((t) => !lockStates[t.id]?.isExcluded && !t.archived).map((t) => t.id)),
    locked: new Set(tasks.filter((t) => lockStates[t.id]?.isLocked && !lockStates[t.id]?.isExcluded).map((t) => t.id)),
    blockers: new Map(tasks.map((t) => [t.id, new Set((lockStates[t.id]?.blockingTasks || []).filter((b) => b.reason !== 'waiting_until').map((b) => b.id || b.taskId))])),
    names: new Map(graph.nodes.map((n) => [n.id, byId.get(n.id)?.name || n.name])),
  };
}

export function detectUnlockIgnition(previous, next) {
  if (!previous || previous.campaignId !== next.campaignId || previous.context !== next.context) return null;
  const completed = new Set([...next.completed].filter((id) => !previous.completed.has(id)));
  if (!completed.size) return null;
  const edges = next.edges.filter(([from, to]) => (
    completed.has(from)
    && previous.locked.has(to)
    && !previous.available.has(to)
    && next.available.has(to)
    && previous.blockers.get(to)?.has(from)
  ));
  if (!edges.length) return null;
  const sourceIds = [...new Set(edges.map(([from]) => from))];
  const targetIds = [...new Set(edges.map(([, to]) => to))];
  return { sourceIds, targetIds, edges, names: targetIds.map((id) => next.names.get(id)) };
}
